<template>
  <div v-show="show" id="thAlert" class="app-alert">
    <div class="app-alert-inner">
      <div class="app-alert-top"><span class="app-alert-title">{{title}}</span></div>
      <div class="app-alert-content" v-html="content"></div>
      <div class="app-alert-bottom">
        <div class="app-alert-reject" @click="reject">{{btnReject}}</div>
        <div class="app-alert-accept" @click="confirm">{{btnAccept}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    btnAccept: String,
    btnReject: String,
    show: Boolean,
    title: String
  },
  data () {
    return {}
  },
  methods: {
    reject () {
      this.$emit('checkReject', {action: 0})
    },
    confirm () {
      this.$emit('checkConfirm', {action: 1})
    }
  }
}
</script>

<style>
#thAlert.app-alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1200;
  background-color: black;
}
#thAlert .app-alert-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 116.8vh;
  height: 63.73333vh;
  border-bottom: 0.53333vh solid #6f6f6f;
  background-color: #272727;
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-inner {
    width: 65.66717vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-inner {
    height: 35.83208vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-inner {
    border-bottom: 0.29985vw solid #6f6f6f;
  }
}
#thAlert .app-alert-top {
  position: relative;
  width: 100%;
  height: 9.06667vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 6.66667vh;
  background-image: linear-gradient(to bottom, #b1b1b1, #f7f5ed);
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-top {
    height: 5.09745vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-top {
    font-size: 3.74813vw;
  }
}
#thAlert .app-alert-top::after {
  content: '';
  position: absolute;
  bottom: 0.13333vh;
  width: 70%;
  height: 0.53333vh;
  background: linear-gradient(to right, rgba(255, 242, 146, 0) 0%, #fff292 20%, #fff292 50%, #fff292 80%, rgba(255, 242, 146, 0) 100%);
  filter: drop-shadow(0 0.1em 0.05em rgba(228, 149, 18, 0.3));
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-top::after {
    bottom: 0.07496vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-top::after {
    height: 0.29985vw;
  }
}
#thAlert .app-alert-title {
  margin-top: 0.53333vh;
  background-image: linear-gradient(to bottom, #333332 10%, #836133);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-title {
    margin-top: 0.29985vw;
  }
}
#thAlert .app-alert-content {
  width: 106.13333vh;
  height: 35.73333vh;
  font-size: 3.73333vh;
  margin: 3.46667vh auto;
  padding: 0.66667vh 2.66667vh;
  font-family: inherit !important;
  overflow: hidden;
  overflow-y: auto;
  background-color: #393939;
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-content {
    width: 59.67016vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-content {
    height: 20.08996vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-content {
    font-size: 2.09895vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-content {
    margin: 1.94903vw auto;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-content {
    padding: 0.37481vw 1.49925vw;
  }
}
#thAlert .app-alert-content *,
#thAlert .app-alert-content *::before,
#thAlert .app-alert-content *::after {
  font-family: inherit !important;
}
#thAlert .app-alert-content p {
  line-height: 4.53333vh;
  font-family: inherit !important;
  color: #fff;
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-content p {
    line-height: 2.54873vw;
  }
}
#thAlert .app-alert-content p span {
  font-family: inherit !important;
}
#thAlert .app-alert-content::-webkit-scrollbar:vertical {
  width: 0.5vw;
}
#thAlert .app-alert-content::-webkit-scrollbar-thumb {
  background-color: #8f8f8f;
}
#thAlert .app-alert-content::-webkit-scrollbar-track {
  background-color: #161616;
}
#thAlert .app-alert-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
}
#thAlert .app-alert-reject,#thAlert .app-alert-accept {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33.86667vh;
  height: 8.26667vh;
  padding-top: 0.66667vh;
  margin: 0 2.4vh;
  font-size: 4.8vh;
  border-radius: 0.53333vh;
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-reject,#thAlert .app-alert-accept {
    width: 19.04048vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-reject,#thAlert .app-alert-accept {
    height: 4.64768vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-reject, #thAlert .app-alert-accept {
    padding-top: 0.37481vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-reject,#thAlert .app-alert-accept {
    margin: 0 1.34933vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-reject,#thAlert .app-alert-accept {
    font-size: 2.69865vw;
  }
}
@media screen and (max-aspect-ratio: 1334 / 750) {
  #thAlert .app-alert-reject,#thAlert .app-alert-accept {
    border-radius: 0.29985vw;
  }
}
#thAlert .app-alert-reject {
  filter: brightness(0.9);
  color: #002757;
  background-image: linear-gradient(to bottom, #008dc1, #007297);
}
#thAlert .app-alert-accept {
  color: #753f00;
  background-image: linear-gradient(to bottom, #fbed65, #f0b64d);
}
</style>



// WEBPACK FOOTER //
// src/components/alert/Alert.vue